<template>
    <div>
        <div id="collage">
            <h2 v-html="task.question"></h2>
            <hr />
            <div class="row">
                <div class="col-6 p-4">
                    <img
                        :src="task.taskable.puzzle_image"
                        class="w-100 mx-auto"
                        alt=""
                    >
                </div>
                <div class="col-6 p-4">
                    Lépések száma: {{ userTask.solution.steps }} <br>
                    Idő: {{ userTask.solution.time }} másodperc<br>
                    <span v-if="userTask.solution.status" class="text-success">A kép sikeresen kirakva!</span>
                    <span v-else class="text-danger">Nem sikerült kirakni a képet!</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        userTask: {
            type: Object,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style>
#collage hr{
    border:none;
    border-top:2px solid #f5f2f2;
    height:1px;
}

#collage #playPanel {
    padding:10px 0px;
    margin: 10px auto;
    max-width:800px;
    width:95%;
}

#collage #stepBox, #collage #timeBox {
    display:inline-block;
    width:48%;
}

#collage #stepBox div {
    background-color:#c2defc;
    display:inline-block;
    padding:1px 4px;
    margin: 0px auto;
    max-width:800px;
}

#collage img#actualImage{
    border:2px solid #a46;
    height:280px;
    width:280px;
}

#collage #sortable {
    border:2px solid #a46;
    list-style-type: none;
    display: inline-block;
    margin: 10px;
    padding: 0;
}

#collage #sortable li {
    background-size: 600% 600%;
    border: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    float: left;
    width: 100px;
    height: 100px;
}

#collage button  {
    background-color:#f5f2f2;
    border:1px solid #cce;
    display: inline;
    font-size: 14px;
    height: auto;
    width: auto;
    padding: 3px 8px;
}
.success {
    border: 2px solid rgba(0, 128, 0, 0.99) !important;
    background-color: rgba(0, 128, 0, 0.1);
    backdrop-filter: blur(2px);
    pointer-events: none;
}
</style>
